import { Flex, Skeleton } from '@chakra-ui/react';
import React from 'react';
import './HeroSectionSkeleton.scss';

const HeroSectionSkeleton = () => {
  return (
    <Flex className={'hero-section-skeleton-container'}>
      <Skeleton className={'hero-section-skeleton'} />
    </Flex>
  );
};

export default HeroSectionSkeleton;
